export default function registerLineItemModal(Alpine) {
  Alpine.data("lineItemModal", (configOrPrices = {}) => {
    const config = Array.isArray(configOrPrices) ? { prices: configOrPrices } : configOrPrices;

    return {
      prices: config.prices || [],
      billingType: config.billingType || "",
      cadence: config.cadence || "",
      productPriceId: config.productPriceId || "",
      unitPrice: config.unitPrice != null ? String(config.unitPrice) : "",
      hourlyRate: config.hourlyRate != null ? String(config.hourlyRate) : "",
      productListPrice: config.productListPrice != null ? Number(config.productListPrice) : null,
      currency: config.currency || "",
      cadenceLabels: config.cadenceLabels || {},

      get isHourly() {
        return this.billingType === "hourly";
      },

      get activePriceNumber() {
        const v = this.isHourly ? this.hourlyRate : this.unitPrice;
        if (v === "" || v == null) return null;
        const n = Number(v);
        return Number.isFinite(n) ? n : null;
      },

      get selectedTier() {
        if (!this.productPriceId) return null;
        return this.prices.find((p) => String(p.id) === String(this.productPriceId)) || null;
      },

      get tierPrice() {
        return this.selectedTier ? Number(this.selectedTier.price) : null;
      },

      get referencePrice() {
        if (this.tierPrice != null) return this.tierPrice;
        return this.productListPrice;
      },

      get isOverridden() {
        if (this.referencePrice == null) return false;
        if (this.activePriceNumber == null) return false;
        return Math.abs(this.activePriceNumber - this.referencePrice) > 0.001;
      },

      get tierOverridden() {
        if (this.tierPrice == null) return false;
        if (this.activePriceNumber == null) return false;
        return Math.abs(this.activePriceNumber - this.tierPrice) > 0.001;
      },

      formatPrice(n) {
        if (n == null || !Number.isFinite(Number(n))) return "";
        return Number(n).toFixed(2);
      },

      applyTier(id) {
        this.productPriceId = id;
        const tier = this.prices.find((p) => String(p.id) === String(id));
        if (!tier) return;
        const val = this.formatPrice(tier.price);
        if (this.isHourly) this.hourlyRate = val;
        else this.unitPrice = val;
      },

      resetToReference() {
        if (this.referencePrice == null) return;
        const val = this.formatPrice(this.referencePrice);
        if (this.isHourly) this.hourlyRate = val;
        else this.unitPrice = val;
      },

      // Legacy alias kept for callers that haven't adopted applyTier (orders modal)
      applyVariantPrice(id) {
        const match = this.prices.find((p) => String(p.id) === String(id));
        if (match && this.$refs && this.$refs.unitPrice) {
          this.$refs.unitPrice.value = this.formatPrice(match.price);
        }
        this.applyTier(id);
      }
    };
  });
}
